import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Card,
  Link,
  Tooltip,
  Typography,
  Container,
  Alert,
  styled
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import useAuth from 'src/hooks/useAuth';
import AmplifyLogin from '../LoginAmplify';
import { useTranslation } from 'react-i18next';
import Logo from 'src/components/LogoPoweredBy';


const MainContent = styled(Box)(
  () => `
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
`
);

const TopWrapper = styled(Box)(
  () => `
  display: flex;
  width: 100%;
  flex: 1;
  padding: 20px;
`
);

function LoginBasic() {
  const { method } = useAuth() as any;
  const { t }: { t: any } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Resort Grocery - Login</title>
      </Helmet>
      <MainContent>
        <TopWrapper>
          <Container maxWidth="sm">
            <Card
              sx={{
                mt: 3,
                px: 4,
                pt: 5,
                pb: 3,
                mb: 5
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    mb: 1
                  }}
                >
                  {t('Manage your order')}
                </Typography>
                <Typography
                  variant="h4"
                  color="text.secondary"
                  fontWeight="normal"
                  sx={{
                    mb: 3
                  }}
                >
                  {t('Please enter the email address associated with your order, along with your Order ID or the billing ZIP code for the card used to place the order.')}
                </Typography>
              </Box>
              {method === 'Amplify' && <AmplifyLogin />}
              {/* <Box my={4}>
                <Typography
                  component="span"
                  variant="subtitle2"
                  color="text.primary"
                  fontWeight="bold"
                >
                  {t('Missing something?')}
                </Typography>{' '}
                <Link component={RouterLink} to="/account/login-basic">
                  <b>Go here</b>
                </Link>
              </Box>

              <Tooltip
                title={t('The tool tip')}
              >
                <Alert severity="warning">
                  Notes here
                </Alert>
              </Tooltip> */}
            </Card>
            <Logo />

            {/* <Alert severity="warning">
              {t(
                'Notes to follow.'
              )}
            </Alert> */}
          </Container>
        </TopWrapper>
      </MainContent>
    </>
  );
}

export default LoginBasic;
